import { useEffect, useState } from 'react';
import { LAUNCH_AT } from '@kartGame/launch';

// Production and `npm start` count down to the premiere alike, so localhost
// shows what the live site will. Staging plays its running season, tests set
// their own clock, and REACT_APP_KARTLIFE_COUNTDOWN=off opens the game locally.
// Light on purpose: the app chooser imports it without pulling in the game.
export const LAUNCH_GATED = process.env.NODE_ENV !== 'test' && process.env.REACT_APP_GAMES_STAGING !== 'true'
  && process.env.REACT_APP_KARTLIFE_COUNTDOWN !== 'off';

export function remaining(ms) {
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  return { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
}

// Milliseconds until `target`, ticking every second and after the tab returns
// from the background; 0 once it has passed or when the build is not gated.
export function useCountdown(target = LAUNCH_AT, { gated = LAUNCH_GATED, now = Date.now } = {}) {
  const left = () => (gated ? Math.max(0, target - now()) : 0);
  const [value, setValue] = useState(left);
  useEffect(() => {
    if (!gated) return undefined;
    const update = () => setValue(Math.max(0, target - now()));
    update();
    if (target - now() <= 0) return undefined;
    const timer = setInterval(update, 1000);
    document.addEventListener('visibilitychange', update);
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange', update); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, gated, now]);
  return value;
}
